var path = '/static/assets/khapps/trial/apps/report_dashboard/member_rapid/form/partials/common_includes/report_footer.html';
var html = "<div class=\"report-template-footer\" ng-bind-html=\"article.template.footer\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;